module.exports = __webpack_public_path__ + "img/arrow.88e1e0d.png";